// Packages:
import { useState } from "react"

// Icons:
import { FaCircleChevronDown, FaCircleChevronUp } from "react-icons/fa6"

// Typescript:
import { weekType } from "./details/courseModule"
interface CoursesAccordianType {
 week: weekType
 index: number
}

const CoursesAccordian = ({week, index}:  CoursesAccordianType) => {
    // State:
    const [isAccordianActive, setIsAccordianActive] = useState<boolean>(false)

    return <div className='border-b-[1px] border-solid border-[#8F8E8E] last:border-b-[0px] py-[20px]'>
    <div className='flex gap-[20px] justify-between items-center md:items-end' key={index}>
        <div className='basis-[100%] md:basis-[65%]'>
            <h3 className='text-[20px] font-semibold'>{week?.title}</h3>
        </div>
        <div className='flex gap-[10px] items-center cursor-pointer' onClick={()=>setIsAccordianActive(!isAccordianActive)}>
            <p className='text-[#4545AF] font-bold hidden md:block'>Module Details</p>
            {isAccordianActive ? <FaCircleChevronUp size={24} color='#4545AF'/> : <FaCircleChevronDown size={24} color='#4545AF'/> }
        </div>
    </div> 
        <div className='mt-[10px] flex gap-[15px] items-center'>
            <p className='text-[#8F8E8E] text-[18px] font-medium'>Module {week?.points?.length}</p>
            <div className='Block h-[4px] w-[4px] bg-[#8F8F8E] rounded-[50%]'></div>
            <p className='text-[#8F8E8E] text-[18px] font-medium'> {`${week?.time} to complete`}</p>
        </div>
        {isAccordianActive && <div className=' mt-[20px]'>
               <div className='mt-[25px]'>
                        {week?.points?.map((module:any)=><div className='mt-[18px] flex flex-wrap gap-[20px] items-center font-medium'>
                            <p>{module?.title}</p>
                    </div>)}
                </div>
            </div>}
    </div>
}

export default CoursesAccordian